import { Component, effect, inject, model } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucidePenLine,
  lucidePackage,
  lucideTrash2,
} from '@ng-icons/lucide';

import { CrudService } from '../../core/services/crud.service';
import { RollFormComponent } from '../roll-form/roll-form.component';
import { ColorTotalComponent } from '../../shared/components/color-total/color-total.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-inventory',
  imports: [NgIcon, RollFormComponent, DecimalPipe, ColorTotalComponent],
  viewProviders: [provideIcons({ lucidePenLine, lucidePackage, lucideTrash2 })],

  templateUrl: './inventory.component.html',
  styles: ``,
})
export class InventoryComponent {
  private crudService = inject(CrudService);
  private router = inject(Router);

  products!: Array<any>;
  existingRoll: any;

  showModal = model(false);

  constructor() {
    effect(() => {
      if (!this.showModal()) {
        this.getProducts();
      }
    });
  }

  openModal() {
    this.existingRoll = null;
    this.showModal.set(true);
  }

  getProducts() {
    this.crudService.getProducts().subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.products = response.body;

          this.products.forEach((product) => {
            if (product.inventory_by_combination.length > 0) {
              product.colors = product.possible_colors.map((color: any) => {
                const roll_count = product.inventory_by_combination
                  .filter((item: any) => item.color === color)
                  .reduce((acc: number, curr: any) => acc + curr.roll_count, 0);

                return {
                  color: color,
                  roll_count: roll_count,
                };
              });
            }
          });
        }
      },
    });
  }

  selectProduct(product: any) {
    this.router.navigate(['/rollos'], {
      state: {
        product: {
          id: product.id,
          name: product.name,
          description: product.description,
        },
      },
    });
  }
}
